export default __webpack_public_path__ + "static/media/teaser-etalinepro-small-fr.ce6b7666.png";